import { useState } from "react";
import { App } from "antd";
import axios from "axios";

import { BACKEND_URL } from "config";
import { useAuth } from "hooks/useAuth";

const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

const useFetch = (url, fetchMethod = "POST", displayError = true, resetStateOnFetch = true, reverseResponseData = false) => {
  const { message } = App.useApp();
  const { logoutUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errorMessage, setErrorMessage] = useState();

  let onError = () => {};
  if (displayError) {
    onError = (errorMessage) => {
      message.error(errorMessage);
    };
  }

  const doFetch = (requestData) => {
    setLoading(true);
    // Reset state
    if (resetStateOnFetch){
      setResponseData({});
    }

    const fetchApi = () => {
      switch (fetchMethod) {
        case "GET":
          return getApi(url, requestData);
        default:
          return postApi(url, requestData);
      }
    };

    return fetchApi()
      .then((response) => response.data)
      .then((response) => {
        if (!!response.error) {
          setErrorMessage(response.error);
          onError(response.error);
        }

        if(reverseResponseData && Array.isArray(response.data.data)){
          response.data.data.reverse()
        }

        setResponseData(response.data ?? {})
        return response;
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          logoutUser();
        } else {
          const responseError = error.response?.data?.error ?? error.message;
          setErrorMessage(responseError);
          onError(responseError);
        }
      })
      .finally(() => setLoading(false));
  };

  return { loading, responseData, errorMessage, doFetch };
};

const getCookie = (key) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const postApi = (url, requestData) => {
  return axiosInstance.post(url, requestData, {
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": getCookie("csrf_access_token"),
    },
  });
};

const getApi = (url, requestData) => {
  return axiosInstance.get(url, {
    params: requestData,
  });
};

export default useFetch;
